module.exports = __webpack_public_path__ + "img/en.2731bcb6.svg";